export type DateInput = string | Date | number | undefined | null;

function parseToDate(value: DateInput): Date | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** Format as YYYY-MM-DD HH:mm. */
export function formatDate(value: DateInput, fallback = '—'): string {
  const date = parseToDate(value);
  if (!date) {
    return fallback;
  }
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

/** Format as YYYY-MM-DD (date only, for chart axis labels). */
export function formatDateOnly(value: DateInput, fallback = '—'): string {
  const date = parseToDate(value);
  if (!date) {
    return fallback;
  }
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}
